import React from 'react'
export const EnvifyFrame = () => (
  <div style={{ height: "80vh", display: 'flex'}}>
    <iframe src="https://envify.ai/authentication/sign-in" width="100%" height="100%" style={{border: "none"}}></iframe>
  </div>
  )
